<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/suppliers')" style="cursor: pointer">Instaladores</li>
        <li class="breadcrumb-item active">Seguimiento perfil proveedores</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="vx-row">
        <!-- TITLE -->
        <div class="vx-col w-full mb-base">
          <vx-card>
            <h1 class="bold big-title m-0">Proveedores en proceso de <span>verificación</span>.</h1>
          </vx-card>
        </div>

        <!-- TABLA -->
        <div class="vx-col w-full">
          <vx-card>
            <vs-tabs>
              <vs-tab label="ONBOARDING COMPLETO">
                <vs-table class="mt-4" style="z-index: 5 !important;" stripe max-items="25" pagination search :data="suppliers"
                  noDataText="No hay datos disponibles">
                  <div slot="header" class="mb-4">
                    <h4>Lista de proveedores</h4>
                    <vs-button size="small" @click.stop="getSuppliersNotVerified()">Actualizar</vs-button>
                  </div>
                  <template slot="thead">
                    <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx"
                      :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].PID">
                        <router-link :to="`/suppliers/${tr.id}`" target='_blank'>
                          {{ tr.id }} | {{ tr.user_id }}
                        </router-link>
                      </vs-td>
                      <vs-td>
                        <strong>{{ tr.tradename }}</strong>
                          <br> {{ tr.user.email }}
                          <br> <strong>tel.</strong> {{ getFiscal(tr.user).country_calling_code }} {{ phoneFormat(getFiscal(tr.user).new_phone) }}
                          <br>
                        <vs-chip class="mt-1" transparent :color="tr.user.person_type == 0 ? 'primary' : 'warning'">
                          {{ tr.user.person_type == 0 ? 'Persona Moral' : 'Persona Física' }}
                        </vs-chip>
                      </vs-td>
                      <vs-td>
                        <small><strong>{{ tr.supplier_onboarding_named }}</strong></small>
                      </vs-td>
                      <vs-td v-if="getSupplierContactByType(tr.contacts, 1)">
                        {{ getSupplierContactByType(tr.contacts, 1).name }}
                        <br> {{ getSupplierContactByType(tr.contacts, 1).email}}
                        <br> <strong>tel.</strong> {{ getSupplierContactByType(tr.contacts, 1).country_calling_code }} {{ phoneFormat(getSupplierContactByType(tr.contacts, 1).phone)}}
                      </vs-td>
                      <vs-td v-else>
                        Sin información
                      </vs-td>
                      <vs-td v-if="getSupplierContactByType(tr.contacts, 2)">
                        {{ getSupplierContactByType(tr.contacts, 2).name }}
                        <br> {{ getSupplierContactByType(tr.contacts, 2).email}}
                        <br> <strong>tel.</strong> {{ getSupplierContactByType(tr.contacts, 2).country_calling_code }} {{ phoneFormat(getSupplierContactByType(tr.contacts, 2).phone)}}
                      </vs-td>
                      <vs-td v-else>
                        Sin información
                      </vs-td>
                      <vs-td>
                        {{ dateTimeFormat(tr.verification_request_date) }}
                      </vs-td>
                      <vs-td class="center">
                        {{ calculateDaysDiff(tr.verification_request_date) }}
                      </vs-td>
                      <vs-td>
                        <div class="triage" :class="setTriageColor(calculateDaysDiff(tr.verification_request_date))"></div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vs-tab>
              <vs-tab label="ONBOARDING EN PROCESO">
                <vs-table class="mt-4" style="z-index: 5 !important;" stripe max-items="25" pagination search :data="suppliersInProcess"
                  noDataText="No hay datos disponibles">
                  <div slot="header" class="mb-4">
                    <h4>Lista de proveedores</h4>
                    <vs-button size="small" @click.stop="getSuppliersInProcess()">Actualizar</vs-button>
                  </div>
                  <template slot="thead">
                    <vs-th class="bold" v-for="(col, idx) in columnsInProcess" v-bind:key="idx"
                      :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].PID">
                        <router-link :to="`/suppliers/${tr.id}`" target='_blank'>
                          {{ tr.id }} | {{ tr.user_id }}
                        </router-link>
                      </vs-td>
                      <vs-td>
                        <strong>{{ tr.tradename }}</strong>
                          <br> {{ tr.user.email }}
                          <br> <strong>tel.</strong> {{ getFiscal(tr.user).country_calling_code }} {{ phoneFormat(getFiscal(tr.user).new_phone) }}
                          <br>
                        <vs-chip class="mt-1" transparent :color="tr.user.person_type == 0 ? 'primary' : 'warning'">
                          {{ tr.user.person_type == 0 ? 'Persona Moral' : 'Persona Física' }}
                        </vs-chip>
                      </vs-td>
                      <vs-td>
                        <small><strong>{{ tr.supplier_onboarding_named }}</strong></small>
                      </vs-td>
                      <vs-td v-if="getSupplierContactByType(tr.contacts, 1)">
                        {{ getSupplierContactByType(tr.contacts, 1).name }}
                        <br> {{ getSupplierContactByType(tr.contacts, 1).email}}
                        <br> <strong>tel.</strong> {{ getSupplierContactByType(tr.contacts, 1).country_calling_code }} {{ phoneFormat(getSupplierContactByType(tr.contacts, 1).phone)}}
                      </vs-td>
                      <vs-td v-else>
                        Sin información
                      </vs-td>
                      <vs-td v-if="getSupplierContactByType(tr.contacts, 2)">
                        {{ getSupplierContactByType(tr.contacts, 2).name }}
                        <br> {{ getSupplierContactByType(tr.contacts, 2).email}}
                        <br> <strong>tel.</strong> {{ getSupplierContactByType(tr.contacts, 2).country_calling_code }} {{ phoneFormat(getSupplierContactByType(tr.contacts, 2).phone)}}
                      </vs-td>
                      <vs-td v-else>
                        Sin información
                      </vs-td>
                      <vs-td>
                        {{ dateTimeFormat(tr.updated_at) }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vs-tab>
            </vs-tabs>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import * as moment from 'moment';
import formatHelper from "@mixins/formatHelper";
import dateHelper from "@mixins/dateHelper";

const columns = [
    { title: "SID | UID", key: "sid_uid", sortable: true }
    , { title: "PROVEEDOR", key: "supplier", sortable: true }
    , { title: "ONBOARDING STEP", key: "onboarding_step", sortable: true }
    , { title: "DIRECTOR GENERAL", key: "dir_gral", sortable: false }
    , { title: "DIRECTOR COMERCIAL", key: "dir_marketing", sortable: false }
    , { title: "SOLICITUD DE REVISIÓN", key: "request_date", sortable: false }
    , { title: "DÍAS TRANSCURRIDOS", key: "days", sortable: true }
    , { title: "TRIAGE", key: "triage", sortable: true }
];

const columnsInProcess = [
    { title: "SID | UID", key: "sid_uid", sortable: true }
    , { title: "PROVEEDOR", key: "supplier", sortable: true }
    , { title: "ONBOARDING STEP", key: "onboarding_step", sortable: true }
    , { title: "DIRECTOR GENERAL", key: "dir_gral", sortable: false }
    , { title: "DIRECTOR COMERCIAL", key: "dir_marketing", sortable: false }
    , { title: "ÚLTIMA ACTUALIZACIÓN", key: "updated_at", sortable: false }
];

const status = 3;
export default {
  name: 'suppliers_not_verified',
  mixins: [formatHelper, dateHelper],
  filters: {
    human_date(date) {
      return moment(date).lang("es").format("D MMM YYYY");
    }
  },
  props: [],
  data() {
    return {
      data: [],
      search: '',
      suppliers: [],
      suppliersInProcess: [],
      buscando: false,
      slas: {},
      redValue: 0,
      yellowValue: 0,
      columns: columns,
      columnsInProcess: columnsInProcess

    }
  },
  async created() {
    const { data } = await axios.get('/api/sla_df_verification');
    this.slas = data;
    this.redValue = parseInt(this.slas.sla_verified[0].val);
    this.yellowValue = parseInt(this.slas.sla_verified[1].val);
    await this.getSuppliersNotVerified();
    await this.getSuppliersInProcess();
  },
  methods: {
    getSuppliersNotVerified() {
      this.showLoading(true);
      axios.post('/api/suppliers/notVerified', {
        status: status,
      })
        .then(response => {
          this.showLoading(false);
          this.suppliers = response.data.suppliers;
        }).catch(error => {
          this.showLoading(false);
          this.errorNotif(error.response.data.message, error.response.data.errors);
        });
    },
    getSuppliersInProcess() {
      this.showLoading(true);
      axios.post('/api/suppliers/in-process', {
        status: status,
      })
        .then(response => {
          this.showLoading(false);
          this.suppliersInProcess = response.data.suppliers;
        }).catch(error => {
          this.showLoading(false);
          this.errorNotif(error.response.data.message, error.response.data.errors);
        });
    },
    searchSupplier() {
      try {
        if (this.search != '') {
          if (this.buscando == false) {
            this.buscando = true;
            axios.post('/api/suppliers/notVerified/search', {
              status: status,
              search: this.search,
            })
              .then(response => {
                this.suppliers = response.data.suppliers;
                this.buscando = false;
              })
              .catch(error => {
                this.errorNotif(error.response.data.message, error.response.data.errors);
              });
          }
        } else {
          this.getSuppliersNotVerified();
        }
      } catch (err) {
        this.errorNotif("Algo ha salido mal.", err);
      }
    },
    setTriageColor(TT) {
      try {
        if (TT > this.redValue) {
          return 'triage-red';
        } else if (TT > this.yellowValue) {
          return 'triage-yellow';
        } else {
          return 'triage-green';
        }
      } catch (err) {
        return '';
      }
    },
    hasToShow(TT) {
      try {
        // let flag = false;
        // if(TT > this.yellowValue){
        //   flag = true;
        // }
        // return flag;
        return true;
      } catch (err) {
        console.error("Algo salió mal en el método hasToShow");
      }
    },
    getFiscal(user) {
      if(user.person_type == 0) {
        return user.business;
      } else {
        return user.personal;
      }
    },
    getSupplierContactByType(contacts, type) {
      const contact = contacts.find(c => c.type == type);
      return contact;
    }
  },
  computed: {

  }
}
</script>
<style scoped>
.triage {
  width: 1.5rem;
  height: 1.5rem;
  background-color: #ccc;
  margin-left: 1.5rem;
  border-radius: 5pc;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

tr.th-left>th {
  text-align: left !important;
}

.triage-red {
  background-color: red !important;
}

.triage-yellow {
  background-color: yellow !important;
}

.triage-green {
  background-color: green !important;
}

.center {
  text-align: center !important;
}

</style>